export const USER_MEMBERSHIP_STATUS_OPTIONS = [
  { value: "1", label: "active" },
  //{ value: "99", label: "pending" },
  { value: "0", label: "inactive" },
  //{ value: "3", label: "rejected" },
  //{ value: "2", label: "banned" },
];

export const USER_MEMBERSHIP_OPTIONS = ["guest", "normal", "vip"];
